import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

export const useRouteChangeReporter = () => {
  const location = useLocation()

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'routeChange',
      },
      '*'
    )
  }, [location])
}
